/* eslint "no-param-reassign": "warn" */
import { Map } from 'immutable';
import every from 'lodash/every';
import isObject from 'lodash/isObject';
import MultiWeakMap from './MultiWeakMap';

// This is a method decorator that helps selectors perform caching via
// WeakMaps. It accepts a function which returns a list of paths to pieces of
// the global Redux store, e.g., ['quizEntries']. It then looks up the value
// being stored in this path and checks to see if the decorated method has been
// called before with the same value, and if so, returns the cached result.
export default (function (fnToGetPaths) {
  return function (target, name, descriptor) {
    var decoratedMethod = descriptor.value;
    var cache;
    descriptor.value = function () {
      var paths = fnToGetPaths(this);
      cache = cache || new MultiWeakMap(paths.length + 1);
      var state = this.state();
      var fields = paths.map(function (path) {
        return state.getIn(path, Map());
      });
      var keys = [this].concat(fields);
      if (cache.has(keys)) {
        return cache.get(keys);
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var result = decoratedMethod.apply(this, args);
      if (allAreObjects(fields)) {
        cache.set(keys, result);
      }
      return result;
    };
    return descriptor;
  };
});
var allAreObjects = function allAreObjects(values) {
  return every(values, isObject);
};